import React from 'react';

import { useUnmount } from 'react-use';
import { observer } from 'mobx-react';

import { useGetNecessaryData } from '../../../shared/hooks/useGetNecessaryData';
import { TaxInfoBlock } from '../../components/TaxInfoBlock/TaxInfoBlock';
import { challengeTaxStore } from '../../stores/challengeTaxStore';

type ChallengeTaxWidgetProps = {
  entityId: number;
};

const ChallengeTaxWidget = observer(({ entityId }: ChallengeTaxWidgetProps) => {
  const { entityTaxRate, changeTaxRate, getTaxInfo, setDefaultValues } =
    challengeTaxStore;

  useGetNecessaryData(async () => {
    await getTaxInfo(entityId);
  });

  useUnmount(setDefaultValues);

  return (
    <TaxInfoBlock
      taxRateInfo={entityTaxRate}
      description={
        <>
          Set the tax percentage based on your state/city.
          <br />
          Upon tax setup, the payment amount will be adjusted to reflect the applicable
          tax.
        </>
      }
      formulaText="Total Payment Amount = Payment Amount + Entity Tax, %"
      isActive={!!entityTaxRate?.id}
      onSetTaxRate={changeTaxRate}
    />
  );
});

export { ChallengeTaxWidget };
